import type { CmsOverlayInstance } from '@/cms/types';

export const CMS_WORKSPACE_UPGRADE_OVERLAY_ID = 'workspace-upgrade';

export function findCmsOverlayIdByInstance(params: {
  overlays: CmsOverlayInstance[];
  instanceId: string;
  type?: string;
  enabledOnly?: boolean;
}) {
  return (
    params.overlays.find((overlay) => {
      if (overlay.instanceId !== params.instanceId) {
        return false;
      }

      if (params.type && overlay.type !== params.type) {
        return false;
      }

      if (params.enabledOnly && !overlay.enabled) {
        return false;
      }

      return true;
    })?.instanceId ?? null
  );
}

export function findCmsOverlayIdByType(params: {
  overlays: CmsOverlayInstance[];
  type: string;
  enabledOnly?: boolean;
}) {
  return (
    params.overlays.find((overlay) => {
      if (overlay.type !== params.type) {
        return false;
      }

      if (params.enabledOnly && !overlay.enabled) {
        return false;
      }

      return true;
    })?.instanceId ?? null
  );
}
